<template>
  <div class="d-summary">
    <div class="title-text-style">Driver Summary</div>
    <div class="select-option block">
      <div class="columns is-vcentered is-multiline is-centered">
        <!-- <div class="columns column">
          <b-field
            class="column is-half"
            label="Select Timeframe"
          >
            <div class="block">
              <b-radio
                v-model="timeframe"
                native-value="day"
              >
                Day
              </b-radio>
              <b-radio
                v-model="timeframe"
                native-value="week"
              >
                Week
              </b-radio>
              <b-radio
                disabled
                v-model="timeframe"
                native-value="month"
              >
                Month
              </b-radio>
            </div>
          </b-field>
          <b-field
            class="column is-half"
            label="Select Timeframe What You Want"
          >
            <b-datepicker
              placeholder="Click to select..."
              v-model="dates"
              range
              icon="calendar-today"
              trap-focus
              :locale="undefined"
              :max-date="maxDate"
              @input="bySelectDates"
            >
            </b-datepicker>
          </b-field>
        </div> -->
        <div class="column">
          <b-field label="Select Branch">
            <b-select
              placeholder="select Branch"
              v-model="selectedBranch"
            >
              <option
                v-for="option in branchs"
                :value="option.name"
                :key="option.name"
                :input="fillterByBranch"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div
      v-if="!nodata"
      class="d-summary-grid"
    >
      <bar-chart
        title='bar-d'
        :chartData="computedDriverData"
        class="d-wewchart"
      />
      <table-info
        :tableData="computedDriverData"
        class="d-table-info"
      />
    </div>
    <div
      v-else
      class="d-summary-grid"
    >
      <database-not-found
        class="d-wewchart"
      />
      <database-not-found
        class="d-table-info"
      />
    </div>
  </div>
</template>

<script>
import branchs from '../setting/branchs'
// import PieChart from '../components/PieChart.vue'
import DatabaseNotFound from '../components/etc/DatabaseNotFound.vue'
import TableInfo from '../components/TableInfo.vue'
import dayjs from 'dayjs'
import BarChart from '../components/BarChart.vue'
export default {
  name: 'DriverSummary',
  // components: { PieChart, TableInfo, DatabaseNotFound, BarChart },
  components: { TableInfo, BarChart, DatabaseNotFound },
  data () {
    return {
      branchs: branchs,
      maxDate: new Date(),
      timeframe: 'day',
      dates: [],
      selectedBranch: 'Aree',
      dayInfo: []
    }
  },
  mounted () {
    // console.log('This mounted')
    // this.$store.commit('summary/clearStoreDetail')
    // this.getStoreData(this.timeframeSelection)
  },
  watch: {
    fillterByBranch () {
      this.computedDriverData()
    },
    timeframe: {
      async handler (val) {
        console.log('What Select', val)
        this.dates = []
        this.$store.commit('summary/clearStoreDetail')
        await this.getStoreData(this.timeframeSelection)
      }
    }
  },
  computed: {
    nodata () {
      return this.$store.getters['summary/haveNoData']
    },
    timeframeSelection () {
      let dayInfo = []
      if (this.timeframe) {
        switch (this.timeframe) {
          case 'day':
            dayInfo = this.getDayjsFormatByTimeframe(0)
            break
          case 'week':
            dayInfo = this.getDayjsFormatByTimeframe(6)
            break
          case 'month':
            dayInfo = this.getDayjsFormatByTimeframe(30)
            break
          default:
            dayInfo = this.getDayjsFormatByTimeframe(0)
            break
        }
      }
      if (this.dates.length) {
        const date1 = dayjs(this.dates[1]).add(dayjs().get('hour'), 'hour')
        const date2 = dayjs(this.dates[0]).add(dayjs().get('hour'), 'hour')
        const dateDiff = date1.diff(date2, 'day')
        dayInfo = [date1, dateDiff]
      }
      console.log('this.dates', this.dates)
      console.log('dateInfo', dayInfo, 'timeframe', this.timeframe)
      return dayInfo
    },
    storeData () {
      return this.$store.getters['summary/storeData']
    },
    driverData () {
      return this.$store.getters['summary/listDriver']
    },
    computedDriverData () {
      const dimensions = ['Driver', 'on-time', 'late', 'percentOn']
      const source = []
      const sourceDer = []
      const driverByBranch = this.fillterByBranch()
      for (const [name, value] of Object.entries(driverByBranch)) {
        const delivered = value.onTime + value.late
        const percentOn = (value.onTime / (value.onTime + value.late)) * 100
        source.push([name, value.onTime, value.late, percentOn])
        sourceDer.push([
          name,
          delivered,
          value.onTime,
          value.late,
          percentOn.toFixed(2)
        ])
      }
      return { dimensions, source, sourceDer }
    },
    getDayjsFormatByTimeframe () {
      return (days) => {
        const date1 = dayjs(new Date())
        const date2 = dayjs(new Date()).subtract(days, 'day')
        const dateDiff = date1.diff(date2, 'day')
        return [date1, dateDiff]
      }
    }
  },
  methods: {
    async getStoreData (timeframe) {
      await this.$store.dispatch('summary/getStoreDetail', {
        timeframe: timeframe
      })
    },
    async bySelectDates () {
      console.log('ARE YOU ????')
      this.$store.commit('summary/clearStoreDetail')
      await this.getStoreData(this.timeframeSelection)
    },
    fillterByBranch () {
      const driverbyBranch = {}
      for (const [name, value] of Object.entries(this.driverData)) {
        if (this.selectedBranch === value.branch) {
          driverbyBranch[`${name}`] = value
        }
      }
      // console.log('driverbyBranch', driverbyBranch)
      return driverbyBranch
    }
  }
}
</script>

<style scoped>
.d-summary {
  /* margin-bottom: 50px;
  padding: 25px; */
}
.title-text-style {
  text-align: left;
  margin-top: 10px;
  margin-left: 0px;
  margin-bottom: 10px;
  font-size: 30px;
  color: #1e4b84;
}
.d-summary-grid {
  display: grid;
  grid-template-columns: 60% auto;
  grid-template-areas:
    'd-select-option d-select-option'
    'd-wewchart d-table-info'
    'd-wewchart d-table-info';
  /* 'd-wewchart d-wewchart'
    'd-wewchart d-wewchart'
    'd-table-info d-table-info'; */
  column-gap: 20px;
  row-gap: 20px;
}
.d-wewchart {
  grid-area: d-wewchart;
  min-height: 550px;
}
.d-table-info {
  grid-area: d-table-info;
  min-height: 190px;
}
.d-select-option {
  grid-area: select-option;
  min-height: 100px;
}
/* .notifications {
    grid-area: notifications;
    min-height: 190px;
}
.subscription {
    grid-area: subscription;
    min-height: 190px;
} */
</style>
